import { CompetitionMatch } from './competition-match'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionMatchSerializer {
  fromJson(json: any): CompetitionMatch {
    const competitionMatch = {
      ...json
    }

    return competitionMatch
  }

  toJson(competitionMatch: CompetitionMatch): any {
    return {
      ...competitionMatch
    }
  }
}
